import { useState, useEffect } from 'react';

import axiosUI from '../../../axiosUI';

export function useChannelHistory(channelId, modalOpen) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const fetchChannelHistory = async () => {
      const url = `/api/channels/${channelId}/history`;

      try {
        setLoading(true);
        const { data } = await axiosUI.get(url);
        setHistory(data);
        setLoading(false);
      } catch (error) {
        setError(true);
        setLoading(false);
      }
    };

    if (modalOpen) {
      fetchChannelHistory();
    }

    return () => {
      setLoading(false);
      setError(false);
      setHistory([]);
    };
  }, [channelId, modalOpen]);

  return [error, loading, history];
}
